import { render } from "./UploadImage.vue?vue&type=template&id=779b8ddc&scoped=true&ts=true"
import script from "./UploadImage.vue?vue&type=script&lang=ts"
export * from "./UploadImage.vue?vue&type=script&lang=ts"

import "./UploadImage.vue?vue&type=style&index=0&id=779b8ddc&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/ZaloOA_LienChieu/ZaloOA_LienChieu_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779b8ddc"]])

export default __exports__